import { useEffect, useState } from "react";

function OneDayPopup({ children, popupId }) {
  const [isPopupShow, setPopupShow] = useState(true);
  const closePopup = (expireDays) => {
    let expire = new Date();
    expire.setTime(expire.getTime() + (expireDays * 24 * 60 * 60 * 1000));
    localStorage.setItem(`${popupId}_popupNoShow`, expire.getTime());
  }

  const checkPopupClose = () => {
    const expireDay = localStorage.getItem(`${popupId}_popupNoShow`);
    let today = new Date();

    if (today.getTime() > expireDay) { // 이렇게 하면 localStorage에 아무것도 저장되어 있지 않을 경우 undefined 거나 null 이므로 true를 반환한다.
      return false;
    } else {
      return true;
    }
  }

  const closePopupToday = () => {
    closePopup(1); // 하루 동안 표시 안 할 것임을 명시
    setPopupShow(false); // 오늘 하루 안 보기 누름과 동시에 팝업 사라짐
  };

  useEffect(() => {
    checkPopupClose() ? setPopupShow(false) : setPopupShow(true);
    // 최초 컴포넌트가 마운트되었을 때, 팝업을 표시할 지 말지 조회
  }, []); 
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <>
      {isPopupShow && (
        <>
          {/* <div className="onday_pops"> */}
            <div className="onday_popup">
              <div className='onday_popup-close-wrap' >

                <div className="onday_main_container" >
                  {children}
                </div>

                <div className="onday_popup_footer">
                  <input type='checkbox' id='check' onClick={closePopupToday} />
                  <label htmlFor='check' onClick={closePopupToday}>오늘 하루 안 보기</label>
                  <div className='onday_popup-close'
                    onClick={() => setPopupShow(false)}>
                    <span className="close_popup_btn">닫기</span>
                  </div>
                </div>

              </div>
            </div>
          {/* </div> */}
        </>
      )}
    </>
  )
}

export default OneDayPopup